export default function useShare() {
  //判断是否是微信
  function isWeixin() {
    const ua = navigator.userAgent.toLowerCase();
    return RegExp(/MicroMessenger/i).test(ua);
  }
  return { isWeixin };
}
